import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RuntimeConfigService } from '../services/config/runtime-config.service';

export const LogbookLoginEnabledGuard: CanActivateFn = () => {
  const config = inject(RuntimeConfigService);
  const router = inject(Router);

  if (config.get('logbookLoginEnabled') === true) {
    return true;
  }

  void router.navigate(['/users']);
  return false;
};
